module.exports = __webpack_public_path__ + "static/media/32-Degrees_gridview.09f7db14.jpg";